/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteAllMemoriesAppRequest} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'
import {DeleteAllMemoriesAppResponse} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'


export const deleteAllMemoriesApp = (request: DeleteAllMemoriesAppRequest, options?: CashRequestOptions) => post<DeleteAllMemoriesAppRequest, DeleteAllMemoriesAppResponse>("/2.0/cash/delete-all-memories-app", request, {...options, rejectOnError: true })